import request from 'superagent/lib/client';
import apiUrlProvider from './ApiURL';

class Config {
    constructor(configData) {
        this.configData = configData;
    }

    static async initialize() {
        const credentials = JSON.parse(localStorage.getItem('scality-credentials')) || '';

        const configData = await new Promise((resolve, reject) => {
            request
                .get(`${apiUrlProvider.apiUrl()}/config`)
                .set('x-access-token', credentials)
                .end((err, response) => {
                    if (err) {
                        reject(err);
                    } else {
                        const resp = JSON.parse(response.text);
                        resolve(resp);
                    }
                });
        });

        return new Config(configData);
    }
}

let configInstance = null;

async function getConfig() {
    if (configInstance === null) {
        configInstance = await Config.initialize()
            .catch(err => {
                throw err;
            });
    }

    return configInstance;
}

module.exports = getConfig;



/** WEBPACK FOOTER **
 ** ./src/utils/Config.js
 **/